import { CommonModule } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";

export interface InformationModalOptions {
  message?: string;
  iconName?: string;
  iconColor?: string;
  iconSize?: string;
  buttonText?: string;
  buttonColor?: string;
}

@Component({
  selector: "app-information",
  templateUrl: "./information.component.html",
  styleUrls: ["./information.component.scss"],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class InformationComponent {
  readonly config = input<InformationModalOptions>({});

  readonly message = computed(() => this.config().message ?? "MODAL.DEFAULTMESSAGE.INFO");
  readonly iconName = computed(() => this.config().iconName ?? "information-circle-outline");
  readonly iconColor = computed(() => this.config().iconColor ?? "primary");
  readonly iconSize = computed(() => this.config().iconSize ?? "4.5em");
  readonly buttonText = computed(() => this.config().buttonText ?? "BTN.OK");
  readonly buttonColor = computed(() => this.config().buttonColor ?? "dark");

  modalState: ModalStateService;

  constructor() {
    this.modalState = inject(ModalStateService);
  }

  close() {
    this.modalState.triggerDismiss("information", true);
  }
}